<div>
  <div class="text-right mb-2">
    <span>
      <div class="button text-uppercase btn-green" (click)="update()">{{"SAVE" |translate}}</div>
    </span>
  </div>
  <div *ngFor="let text of workWithUs">
    <img [src]="getFlag(text.lang)" width="30" class="mb-1">
    <div class="content-rich mb-4">
      <quill-editor [preserveWhitespace]="true" [styles]="{height: '300px', border: '1px solid transparent', 'border-top': '0px'}"
      [(ngModel)]="text.description" placeholder="Clicca modifica per inserire descrizione"
      [modules]="modules"></quill-editor>
      <!-- (onEditorChanged)="changedEditor($event)" -->
    </div>
  </div>


</div>
